
import { ButtonTypes } from '@/types';
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'ButtonInputStyleProvider',
  props: {
    type: {
      type: String as PropType<ButtonTypes>,
      required: false,
      default: 'primary'
    }
  }
});
